import { getClassNames } from '@websolutespa/bom-core';
import { LlmChunkText, LlmHistory, useLlm } from '@websolutespa/bom-mixer-llm';
import { Trash2Icon } from 'lucide-react';
import style from './history-item.module.scss';

export const HistoryItem: React.FC<{ item: LlmHistory }> = ({ item }) => {
  const message = useLlm(state => state.message);
  const { setHistory, removeHistory } = useLlm(state => state.actions);
  // console.log('HistoryItem', item);
  return (
    <button type="button" className={getClassNames(style.historyItem, { [style.active]: message === item.assistant })} onClick={() => setHistory(item)}>
      {item.user && (
        <div className={style.user}>{getFirstUserMessage(item)}</div>
      )}
      <div className={style.remove} onClick={(e) => {
        e.preventDefault();
        removeHistory(item);
      }}>
        <Trash2Icon />
      </div>
    </button>
  );
};

function getUserMessages(item:LlmHistory):string[] {
  const userMessages = item.messages
    .filter((x,i) => x.role === 'user')
    .map(x => x.chunks.filter(x => x.type === 'text').map(x => (x as LlmChunkText).text).join(' '))
    .map(x => {
      if (!x) {
        return item.user.text;
      }
      return x;
    });
  return userMessages;
}

function getFirstUserMessage(item:LlmHistory) {
  const userMessages = getUserMessages(item);
  return userMessages.length > 0 ? userMessages[0] : item.user.text;
}
